import React from "react";
import PropTypes from "prop-types";
import { Header as SemanticHeader } from "semantic-ui-react";
import "./Header.scss";

export const Header = ({
  size = "h1",
  text,
  noMargin = false,
  ...props
}) => {
  return (
    <SemanticHeader
      as={size}
      {...props}
      className={`hireart-ds-header ${noMargin === true ? "no-margin" : ""} ${
        props.className
      }`}
    >
      {props.children || text}
    </SemanticHeader>
  );
};

Header.propTypes = {
  size: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  text: PropTypes.string,
  noMargin: PropTypes.bool,
};

